import React, { useState } from 'react';

interface SummaryProps {
  format: 'songs' | 'playlists' | 'timeline' | null;
  records: number;
  dateRange?: { start: string; end: string };
  fields: string[];
  repaired?: { count: number; lines?: number[] };
  skipped?: number;
  sample?: any[];
  onDownloadCleaned?: () => void;
}

export const PreviewSummary: React.FC<SummaryProps> = ({ format, records, dateRange, fields, repaired, skipped, sample = [], onDownloadCleaned }) => {
  const [showSamples, setShowSamples] = useState(false);

  return (
    <div className="space-y-3">
      <div className="text-sm text-gray-800 dark:text-gray-200">
        We’ll import {records.toLocaleString()} row{records === 1 ? '' : 's'}{format ? ` of ${format}` : ''}{dateRange ? ` from ${new Date(dateRange.start).toLocaleDateString()} to ${new Date(dateRange.end).toLocaleDateString()}` : ''}.
      </div>
      <div className="text-xs text-gray-600 dark:text-gray-400">
        Fields detected: {fields.join(', ')}
      </div>
      {(repaired?.count || skipped) && (
        <div className="text-xs text-gray-600 dark:text-gray-400">
          {repaired?.count ? (
            <div>Fixed minor formatting in {repaired.count} row{repaired.count === 1 ? '' : 's'}.</div>
          ) : null}
          {skipped ? (
            <div>Skipped {skipped} row{skipped === 1 ? '' : 's'} we couldn’t read.</div>
          ) : null}
          {onDownloadCleaned && repaired?.count ? (
            <button onClick={onDownloadCleaned} className="mt-1 inline-flex items-center px-2 py-1 rounded border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800">Download cleaned CSV</button>
          ) : null}
        </div>
      )}
      <div>
        <button onClick={() => setShowSamples(v => !v)} className="text-sm underline text-gray-700 dark:text-gray-300">
          {showSamples ? 'Hide sample rows' : 'Show 5 sample rows'}
        </button>
        {showSamples && (
          <div className="mt-2 space-y-1 text-xs text-gray-700 dark:text-gray-300">
            {sample.slice(0,5).map((r, i) => (
              <div key={i} className="flex items-center gap-2">
                <span className="text-gray-500">•</span>
                <span className="truncate">{JSON.stringify(r)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

